import React, {useState, Fragment, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Fab from '@material-ui/core/Fab'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'

// Material-UI Icon
import FolderIcon from '@material-ui/icons/Folder'
import StorageIcon from '@material-ui/icons/Storage'

// Custom Component
import AttachmentChip from '../Chip/AttachmentChip'

// Custom Style
import {relatedItemFileZoneContentStyle} from '../../styles/jss/components/drawingRegister/relatedItemFileZoneContentStyle'

// Fetch Data
import {fileDownload} from '../../dataSource/fileManager'


const useStyles = makeStyles(theme => relatedItemFileZoneContentStyle(theme))

const RelatedItemFileZoneContent = props => {
	const store = require('store')
	const dispatch = useDispatch()

	const classes = useStyles()
	const {title, fileType, open, fileRemoveAction, viewFileAction, openFileManagerDialog} = props

	// Redux Data
	const relatedItemPropertyRedux = useSelector(state => state.relatedItemPropertyRedux)
	const fileUploadingPropertyRedux = useSelector(state => state.fileUploadingPropertyRedux)


	
	const downloadFileAction = (fileCat, fileSeq) => {
		fileDownload(fileCat, fileSeq).then(res => {
			console.log("*****************************************************************************")
			console.log("System Module: Document Submission")
			console.log("Message: File download successful.")
			console.log("*****************************************************************************")
		})
	}


	useEffect(() => {
		// setSubmissionCreateProperty(documentSubmissionCreateValueRedux)
	})


	return (
		// console.log("Drawing  (Redux) | Variable: relatedItemPropertyRedux (DrawingFileZoneContent.js)"),
		// console.log(relatedItemPropertyRedux),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div className={classes.messageAttachmentArea}>
				{
					fileUploadingPropertyRedux !== null ?
						fileUploadingPropertyRedux.map((res, index) => {
							return (
								<AttachmentChip
									key={index}
									id={index}
									filename={res.name}
									fileSize={res.filesize}
									fileExtension={"other"}
									uploading={true}
									viewFileAction={null}
									downloadFileAction={null}
									fileRemoveAction={null}
								/>
							)
						})
					: ""
				}

				{
					relatedItemPropertyRedux ?
						relatedItemPropertyRedux.files.map((res, index) => {
							return (
								<AttachmentChip
									key={index}
									id={res.file_seq}
									filename={res.filename}
									fileSize={res.filesize}
									fileExtension={res.extension}
									viewFileAction={() => viewFileAction("master", res.file_seq, res.filename)}
									downloadFileAction={null}
									fileRemoveAction={() => fileRemoveAction(res)}
								/>
							)
						})
					: ""
				}
			</div>

			<Box className={classes.addFileBtnArea}>
				<Tooltip title="Add File From eFiling">
					<Fab color="primary" size="small" aria-label="add_recipient" className={classes.addFileBtn} onClick={openFileManagerDialog}>
						<FolderIcon />
					</Fab>
				</Tooltip>

				<Tooltip title="Add File From Hard Disk">
					<Fab color="primary" size="small" aria-label="add_recipient" className={classes.addFileBtn} onClick={open}>
						<StorageIcon />
					</Fab>
				</Tooltip>
			</Box>
		</Fragment>
	)
}

export default RelatedItemFileZoneContent